import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router-dom';
import {i18n} from 'src/i18n';
import actions from 'src/modules/gestorDocumental/view/gestorDocumentalViewActions';
import selectors from 'src/modules/gestorDocumental/view/gestorDocumentalViewSelectors';
import GestorDocumentalView from 'src/view/gestorDocumental/view/GestorDocumentalView';
import GestorDocumentalViewToolbar from 'src/view/gestorDocumental/view/GestorDocumentalViewToolbar';
import ContentWrapper from 'src/view/layout/styles/ContentWrapper';
import Breadcrumb from 'src/view/shared/Breadcrumb';
import PageTitle from 'src/view/shared/styles/PageTitle';

function GestorDocumentalPage() {
  const dispatch = useDispatch();
  const match = useRouteMatch();

  const loading = useSelector(selectors.selectLoading);
  const record = useSelector(selectors.selectRecord);

  useEffect(() => {
    dispatch(actions.doFind(match.params.id));
  }, [dispatch, match.params.id]);

  return (
    <>
      <Breadcrumb
        items={[
          [i18n('dashboard.menu'), '/'],
          [i18n('entities.gestorDocumental.menu'), '/gestor-documental'],
          [i18n('entities.gestorDocumental.view.title')],
        ]}
      />

      <ContentWrapper>
        <PageTitle>{i18n('entities.gestorDocumental.view.title')}</PageTitle>

        <GestorDocumentalViewToolbar match={match} />

        <GestorDocumentalView loading={loading} record={record} />
      </ContentWrapper>
    </>
  );
}

export default GestorDocumentalPage;
